import React from "react";
import { useTranslation } from "react-i18next";
import { LEVELS } from "../constants";
import styles from "../OnboardingWizard.module.scss";

interface Props {
  value: string | null;
  onChange: (level: string) => void;
}

const LevelStep: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.stepContent}>
      <h2 className={styles.stepTitle}>{t("onboarding.levelTitle")}</h2>
      <p className={styles.stepSubtitle}>{t("onboarding.levelSubtitle")}</p>

      <div className={styles.grid3x2}>
        {LEVELS.map((level) => {
          const selected = value === level;
          return (
            <button
              key={level}
              type="button"
              className={`${styles.levelCard} ${selected ? styles.cardSelected : ""}`}
              onClick={() => onChange(level)}
            >
              <span className={styles.levelCode}>{level}</span>
              <span className={styles.levelDesc}>
                {t(`onboarding.levels.${level}`)}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default LevelStep;
